export class LabTestModel {
    test_code: string
    lab_test: string
    test_desc: string
    result_length: string
    unit: string
    dog_low: string
    dog_high: string
    cat_low: string
    cat_high: string
    seq_no: string
    up_down: number

    constructor(
        test_code: string,
        lab_test: string,
        test_desc: string,
        result_length: string,
        unit: string,
        dog_low: string,
        dog_high: string,
        cat_low: string,
        cat_high: string,
        seq_no: string
    ) {
        this.test_code = test_code
        this.lab_test = lab_test
        this.test_desc = test_desc
        this.result_length = result_length
        this.unit = unit
        this.dog_low = dog_low
        this.dog_high = dog_high
        this.cat_low = cat_low
        this.cat_high = cat_high
        this.seq_no = seq_no
    }
}